module.exports = __webpack_public_path__ + "static/media/Faruzan.820230e5.png";